import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EventDescription = ({ event }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const shouldTruncate = event?.description?.length > 300;
  const displayText = shouldTruncate && !isExpanded 
    ? event?.description?.substring(0, 300) + '...'
    : event?.description;

  return (
    <div className="bg-card rounded-lg p-6 mb-8">
      <h2 className="text-2xl font-semibold text-foreground mb-4">About This Event</h2>
      <div className="prose prose-slate max-w-none">
        <p className="text-foreground leading-relaxed whitespace-pre-line">
          {displayText}
        </p>
      </div>
      {shouldTruncate && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
          iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
          className="mt-4 text-primary hover:text-primary/80"
        >
          {isExpanded ? 'Show Less' : 'Read More'}
        </Button>
      )}
      {/* Event Tags */}
      {event?.tags && event?.tags?.length > 0 && (
        <div className="mt-6 pt-6 border-t border-border">
          <h3 className="text-sm font-medium text-muted-foreground mb-3">Event Tags</h3>
          <div className="flex flex-wrap gap-2">
            {event?.tags?.map((tag, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-muted text-muted-foreground text-sm rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      )}
      {/* Event Details */}
      <div className="mt-6 pt-6 border-t border-border grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Users" size={20} className="text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Capacity</p>
            <p className="font-medium text-foreground">{event?.capacity} people</p>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Clock" size={20} className="text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Duration</p>
            <p className="font-medium text-foreground">{event?.duration}</p>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Calendar" size={20} className="text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Age Limit</p>
            <p className="font-medium text-foreground">{event?.ageLimit}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDescription;